import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useLocation, type LinkProps } from "@tanstack/react-router";
import type { RoutePath } from "~/shared/constants";

interface BackNavigationConfig {
  route: LinkProps["to"];
  label: string;
}

const getRoute = (t: TFunction<readonly ["general"]>, url: string) => {
  const ROUTES: Partial<Record<RoutePath, BackNavigationConfig>> = {
    "/search-terms": {
      route: "/search-terms",
      label: t("general:header.searchTerms"),
    },
    "/search-terms/amazon": {
      route: "/search-terms/amazon",
      label: t("general:header.searchTerms"),
    },
    "/": {
      route: "/",
      label: t("general:header.home"),
    },
  };

  return (
    ROUTES[url as keyof Partial<Record<RoutePath, BackNavigationConfig>>] ??
    null
  );
};

export const useBackNavigation = () => {
  const location = useLocation();
  const { t } = useTranslation(["general"]);

  const fromUrl = location.state.from;

  return fromUrl ? getRoute(t, fromUrl) : null;
};
